import { createContext } from "react";

const OutlineTableContext = createContext(null);

export default OutlineTableContext;
